<div class="navblock">
  <button class="btnadd" (click)="openCreateModal()">{{'Add task'|translate}}</button>
  <app-group-filter #groupFilter [isEditable]="false"></app-group-filter>
  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
           (input)="onTermChange($event)" />
  </div>
  <div></div>
  <div class="inputgroup">
    <input type="text" class="dtpickerupleft" value="" />
  </div>
  <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
</div>
<div class="tablewrap">
  <div class="table">
    <table fixedcols="[0, 6]" id="exporttable">
      <tr>
        <th>
            <switch-all-checkbox [items]="getObjects() | tasksFilter : filter" />
        </th>
        <th>{{'Object'|translate}}</th>
        <th>{{'Name'|translate}}</th>
        <th>{{'Description'|translate}}</th>
        <th>{{'Time'|translate}}</th>
        <th>{{'Repeat'|translate}}</th>
        <th>{{'Target'|translate}}</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let task of getObjects() | tasksFilter : filter">
        <td>
          <input type="checkbox" [(ngModel)]="task.IsChecked"/>
        </td>
        <td>{{task.Tracker.Name}}</td>
        <td>{{task.Name}}</td>
        <td>{{task.Description}}</td>
        <td>{{task.TaskCompletedDate | datetime:'%0D.%0M.%0Y %0h:%0m'}}</td>
        <td>{{getRepeat(task)}}</td>
        <td>{{getTarget(task)}}</td>
        <td>
          <button class="btn_img btn_location2" (click)="showOnMap(task)"></button>
          <button class="btn_img btn_edit" (click)="openEditModal(task)" title="{{'Edit'|translate}}"></button>
          <button class="btn_img btn_trush " (click)="deleteObject(task.Id)" title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [items]="getObjects() | tasksFilter : filter"></app-footer-component>
<template #mgmtDialog></template>
<template #groupMgmtDialog></template>
<template #objectsListDialog></template>
